/**
 * Set breaking news cookie if the close button is pressed.
 */
export default function () {
  const callToAction = document.querySelector('.call-to-action');

  if (! callToAction) {
    return;
  }

  const close = document.querySelector('.call-to-action__close');

  // If the breaking news cookie doesn't exist remove the hidden class.
  if (0 === document.cookie.split(';')
    .filter((x) => x.includes('call-to-action')).length)
  { // eslint-disable-line brace-style
    callToAction.classList.remove('call-to-action--hidden');
    callToAction.removeAttribute('aria-hidden');
    document.body.classList.add('has-call-to-action');
  }

  // When the close button is clicked add the cookie and the hidden class.
  if (close) {
    close.addEventListener('click', () => {
      callToAction.classList.add('call-to-action--hidden');
      callToAction.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('has-call-to-action');

      const date = new Date();
      // Set cookie to last for 1 day for this particular News Alert post
      date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000));
      // eslint-disable-next-line max-len
      document.cookie = `call-to-action=true; expires="${date.toUTCString()}"; path=/`;
    });
  }
}
